import React from 'react';
interface HeatMapLegendProps {
  metric: 'count' | 'value';
  maxValue: number;
}
export function HeatMapLegend({
  metric,
  maxValue
}: HeatMapLegendProps) {
  const formatValue = (value: number) => {
    if (metric === 'value') {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        notation: 'compact',
        maximumFractionDigits: 1
      }).format(value);
    }
    return `${value} deals`;
  };
  const gradientStops = [0, 0.25, 0.5, 0.75, 1];
  return <div className="bg-white border border-slate-200 rounded-lg p-4" data-id="element-71">
      <h3 className="text-sm font-semibold text-slate-900 mb-3" data-id="element-72">
        {metric === 'count' ? 'Deal Count' : 'Pipeline Value'}
      </h3>

      <div className="space-y-3" data-id="element-73">
        {/* Color gradient bar */}
        <div className="relative" data-id="element-74">
          <div className="h-8 rounded-lg overflow-hidden bg-gradient-to-r from-slate-100 via-blue-300 via-blue-500 to-blue-700" data-id="element-75"></div>
          <div className="flex justify-between mt-2 text-xs text-slate-600" data-id="element-76">
            <span data-id="element-77">0</span>
            <span data-id="element-78">{formatValue(maxValue)}</span>
          </div>
        </div>

        {/* Bottleneck indicator */}
        <div className="pt-3 border-t border-slate-200" data-id="element-79">
          <div className="flex items-center space-x-2 mb-2" data-id="element-80">
            <div className="w-4 h-4 rounded bg-gradient-to-br from-orange-400 to-red-500" data-id="element-81"></div>
            <span className="text-xs text-slate-700 font-medium" data-id="element-82">
              Bottleneck Alert
            </span>
          </div>
          <p className="text-xs text-slate-500" data-id="element-83">
            Stages with unusually high concentration may indicate bottlenecks
          </p>
        </div>

        {/* Empty cell indicator */}
        <div className="flex items-center space-x-2" data-id="element-84">
          <div className="w-4 h-4 rounded bg-slate-50 border-2 border-dashed border-slate-200" data-id="element-85"></div>
          <span className="text-xs text-slate-500" data-id="element-86">No deals</span>
        </div>
      </div>
    </div>;
}